// src/components/outreach/BoardColumn.tsx
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { Pitch, PitchStatus } from '../../types/outreach';
import { PitchCard } from './PitchCard';
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface BoardColumnProps {
  id: PitchStatus;
  title: string;
  pitches: Pitch[];
  onCompose?: (pitch: Pitch) => void;
}

export function BoardColumn({ id, title, pitches, onCompose }: BoardColumnProps) {
  const { setNodeRef, isOver } = useDroppable({ id });

  return (
    <div 
        className={cn(
            "w-[280px] min-w-[280px] shrink-0 flex flex-col rounded-lg border h-full transition-colors",
            isOver ? "bg-accent/50 border-primary ring-2 ring-primary/20" : "bg-slate-50/50 border-border"
        )}
    >
      <div className="p-3 border-b border-border flex items-center justify-between">
            <h3 className="font-semibold text-sm text-foreground">
                {title}
            </h3>
            <Badge variant="secondary" className="rounded-sm px-1.5 py-0.5 text-xs font-normal">
                {pitches.length}
            </Badge>
      </div>
      
      <div 
        ref={setNodeRef} 
        className="p-2 flex-1 overflow-y-auto min-h-[100px]"
      >
        <SortableContext items={pitches.map(p => p.id)} strategy={verticalListSortingStrategy}>
          {pitches.map((pitch) => (
            <PitchCard key={pitch.id} pitch={pitch} onCompose={onCompose} />
          ))}
        </SortableContext>
      </div>
    </div>
  );
}
